import { MouseEvent } from 'react';
import { NavLink } from 'react-router';
import styled from 'styled-components';
import { FlexRowMiddle } from '../shared/Flex';
import { Breakpoints } from '../CSSHelper';
import { Text } from '../shared/Text';
import { ButtonWhite } from '../shared/Buttons';

const StyledNav = styled.nav`
	width: 100%;
	padding: 0 3rem;
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 3rem;
	background-color: ${({ theme }) => theme.nav_bg};

	border-bottom: 1px solid ${({ theme }) => theme.border};

	position: fixed;
	top: 0;

	z-index: 2;

	backdrop-filter: blur(15px);

	@media (max-width: ${Breakpoints.TABLET}) {
		height: 67px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		padding: 2rem;
		row-gap: 2rem;
	}
`;

const StyledNavLinks = styled(FlexRowMiddle)`
	column-gap: 2.5rem;
	a {
		height: 100%;
		padding: 2.5rem 0;
		color: ${({ theme }) => theme.nav_alt_fg};
		font-size: 1.4rem;
		font-weight: 400;
		font-family: ${({ theme }) => theme.FONTS_PRIMARY};
		border-bottom: 2px solid transparent;
		&:hover {
			color: ${({ theme }) => theme.nav_fg};
		}
		&.navLinkActive {
			color: ${({ theme }) => theme.nav_fg};
			border-bottom-color: ${({ theme }) => theme.nav_fg};
		}
	}
	@media (max-width: ${Breakpoints.TABLET}) {
		margin-left: auto;

		a {
			padding: 0 0 0.5rem 0;
		}
	}
`;

const StyledNavActions = styled(FlexRowMiddle)`
	column-gap: 1rem;
	margin-left: auto;
	@media (max-width: ${Breakpoints.TABLET}) {
		width: calc(100vw - 40px);
		height: 45px;
		padding: 5px 10px;
		grid-column: 1 / span 2;

		position: fixed;
		top: calc(100vh - 20px - 40px);
		border-radius: 18px;
		border: 2px solid;
		border-color: rgba(255, 255, 255, 0.15);
		background-color: #085952;
		box-shadow: 0 0 10px 5px rgb(60, 60, 60, 0.6);
		button {
			width: 100%;
			border-radius: 15px;
		}
	}
`;

export function Nav({
	actions,
}: {
	actions?: { text: string; action: (e: MouseEvent) => void; disabled?: boolean }[];
}) {
	return (
		<StyledNav>
			<Text $color="nav_fg" $size="2rem" $weight="500">
				Xip Tix Dash
			</Text>
			<StyledNavLinks>
				<NavLink to="/orders" className={({ isActive }) => (isActive ? 'navLinkActive' : '')}>
					Orders
				</NavLink>
				<NavLink to="/sales" className={({ isActive }) => (isActive ? 'navLinkActive' : '')}>
					Sales
				</NavLink>
				<NavLink to="/cards" className={({ isActive }) => (isActive ? 'navLinkActive' : '')}>
					Cards
				</NavLink>
			</StyledNavLinks>
			{actions && (
				<StyledNavActions>
					{actions.map((action, index) => (
						<ButtonWhite key={`nav_action_${index}`} disabled={action?.disabled} onClick={action.action}>
							{action.text}
						</ButtonWhite>
					))}
				</StyledNavActions>
			)}
		</StyledNav>
	);
}
